import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  coverImage: string;
  rating: number;
  year: number;
  subcategory: string;
  badge?: string;
  category: string;
}

export default function MovieCard({ id, title, coverImage, rating, year, subcategory, badge, category }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {badge && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-[11px] font-medium bg-primary-500 text-white whitespace-nowrap">
            {badge}
          </span>
        )}

        <div className="absolute top-2 right-2 flex items-center gap-1 px-1.5 py-0.5 rounded bg-black/60 text-white text-xs font-medium">
          <i className="ri-star-fill text-accent-400 text-[10px]"></i>
          {rating}
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-white text-xs line-clamp-2 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-75">
            {year} · {subcategory}
          </p>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1 leading-snug">
          {title}
        </h3>
        <p className="text-xs text-foreground-400 mt-1">
          {year} · {subcategory}
        </p>
      </div>
    </Link>
  );
}